import {
  Box,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import { useEffect, useState } from "react";
import { MIDIA_OPTIONS_CANAL_DIRETO } from "../../constants/midia";
import { UF_SIGLAS } from "../../constants/UF";
import { useBudgetFormContext } from "../../context/BudgetFormContext";
import { getCallStatusOptions } from "../../services/callCenterService";

const BudgetRegisterCanalDiretoForm = () => {
  const { budgetRequestCanalDireto, changeBudgetRequestFormCanalDireto } =
    useBudgetFormContext();

  const [statusOptions, setStatusOptions] = useState([]);

  const midiaOptions = MIDIA_OPTIONS_CANAL_DIRETO;

  const listaEstados = UF_SIGLAS;

  useEffect(() => {
    const fetchOptions = async () => {
      const options = await getCallStatusOptions(4);
      setStatusOptions(options);
    };
    fetchOptions();
  }, []);


  return (
    <Card>
      <Box sx={{ p: 3, minWidth: 1050, backgroundColor: "#f9fafb" }}>
        <Grid container spacing={3}>
          <Grid item size={3}>
            <TextField
              fullWidth
              label="Agência"
            error={budgetRequestCanalDireto.budgetAgenciaError}
            helperText={budgetRequestCanalDireto.budgetAgenciaError && 'Digite o nome da agência'}
              required
              value={budgetRequestCanalDireto.budgetAgencia}
              onChange={(e) => {
                    changeBudgetRequestFormCanalDireto("budgetAgenciaError", (e.target.value === ""))   
                    changeBudgetRequestFormCanalDireto("budgetAgencia", e.target.value)
                }}
            />
          </Grid>

          <Grid item size={3}>
            <FormControl fullWidth required>
              <InputLabel id="estado-label">Estado</InputLabel>
              <Select
                labelId="estado-label"
                error={budgetRequestCanalDireto.budgetEstadoError}
                helperText={budgetRequestCanalDireto.budgetEstadoError && 'Escolha o estado'}
                value={budgetRequestCanalDireto.budgetEstado}
                onChange={(e) => {
                    changeBudgetRequestFormCanalDireto("budgetEstadoError", (e.target.value === 0))   
                    changeBudgetRequestFormCanalDireto("budgetEstado", e.target.value)
                }}
                sx={{color: budgetRequestCanalDireto.budgetEstadoError ? '#d32f2f' : '#082b49'}}
              >
                <MenuItem 
                  value={0}
                  sx={{
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                  }}
                >
                  Selecione um estado
                </MenuItem>
                {listaEstados.map((estado) => (
                  <MenuItem key={estado} value={estado}>
                    {estado}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item size={3}>
            <TextField
                fullWidth
                error={budgetRequestCanalDireto.budgetExecutivoError}
                helperText={budgetRequestCanalDireto.budgetExecutivoError && 'Digite o nome do executivo'}
                label="Executivo"
                required
                value={budgetRequestCanalDireto.budgetExecutivo}
                onChange={(e) => {
                    changeBudgetRequestFormCanalDireto("budgetExecutivoError", (e.target.value === ""))   
                    changeBudgetRequestFormCanalDireto("budgetExecutivo", e.target.value)
                }}
            />
          </Grid>

          <Grid item size={6}>
            <FormControl fullWidth required>
              <InputLabel id="motivo-label">Motivo</InputLabel>
              <Select
                labelId="motivo-label"
                error={budgetRequestCanalDireto.budgetMotivoError}
                helperText={budgetRequestCanalDireto.budgetMotivoError && 'Escolha um motivo'}
                value={budgetRequestCanalDireto.budgetMotivo}
                onChange={(e) => {
                    changeBudgetRequestFormCanalDireto("budgetMotivoError", (e.target.value === 0))   
                    changeBudgetRequestFormCanalDireto("budgetMotivo", e.target.value)
                }}
                sx={{color: budgetRequestCanalDireto.budgetMotivoError ? '#d32f2f' : '#082b49'}}
              >
                <MenuItem 
                  value={0}
                  sx={{
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                  }}
                >
                  Selecione um motivo
                </MenuItem>
                {statusOptions.map((item) => (
                  <MenuItem 
                    key={item.id} 
                    value={item.id} 
                    sx={{
                        fontFamily: 'Montserrat',
                    }}
                  >
                    {item.ds_status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item size={3}>
            <FormControl fullWidth required>
              <InputLabel id="midia-label">Mídia</InputLabel>
              <Select
                labelId="midia-label"
                error={budgetRequestCanalDireto.budgetMidiaError}
                helperText={budgetRequestCanalDireto.budgetMidiaError && 'Escolha uma midia'}
                value={budgetRequestCanalDireto.budgetMidia}
                onChange={(e) => {
                    changeBudgetRequestFormCanalDireto("budgetMidiaError", (e.target.value === 0))   
                    changeBudgetRequestFormCanalDireto("budgetMidia", e.target.value)
                }}
                sx={{color: budgetRequestCanalDireto.budgetMidiaError ? '#d32f2f' : '#082b49'}}
              >
                <MenuItem 
                  value={0}
                  sx={{
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                  }}
                >
                  Selecione uma mídia
                </MenuItem>
                {midiaOptions.map((midia) => (
                  <MenuItem key={midia.id} value={midia.ds_midia}>
                    {midia.ds_midia}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item size={6}>
            <TextField
              fullWidth
              label="Observações"
              multiline
              minRows={1}
              value={budgetRequestCanalDireto.budgetObservacao}
              onChange={(e) =>
                changeBudgetRequestFormCanalDireto("budgetObservacao", e.target.value)
              }
            />
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default BudgetRegisterCanalDiretoForm;
